// Storage abstraction for P0 (guest data stays ON DEVICE — privacy hard rule).
// Native driver = expo-sqlite; web driver = localStorage (web is a dev-preview
// target only; expo-sqlite web support is alpha and needs WASM/COOP headers).

export const TABLES = {
  entries: 'budget_entry',
  goals: 'savings_goal',
  contributions: 'goal_contribution',
  policies: 'policy',
  reminders: 'reminder',
  incomeSources: 'income_source',
  incomeEntries: 'income_entry',
  fixedCosts: 'fixed_cost',
} as const;

// INTENT: tables that must NEVER travel in the cloud/household blob. They are
// deliberately NOT in TABLES, because exportSnapshot() loops
// Object.values(TABLES) — staying out of that object IS the exclusion
// mechanism (structural, nothing to forget). forecast_snapshot is a per-device
// observation log; merging two devices' rows (id = day ISO) would overwrite
// one phone's true history with another's.
export const LOCAL_ONLY_TABLES = {
  forecastSnapshots: 'forecast_snapshot',
} as const;

export type TableName =
  | (typeof TABLES)[keyof typeof TABLES]
  | (typeof LOCAL_ONLY_TABLES)[keyof typeof LOCAL_ONLY_TABLES];

export interface DocStore {
  init(): Promise<void>;
  list<T>(table: TableName): Promise<T[]>;
  upsert(table: TableName, id: string, doc: unknown): Promise<void>;
  remove(table: TableName, id: string): Promise<void>;
  getKv(key: string): Promise<string | null>;
  setKv(key: string, value: string): Promise<void>;
}
